import { EmptyState, ErrorBlock, IdleState, LoadingRow } from './StatusStates';
import { DuplicateClusterCard } from './DuplicateClusterCard';
import type { DuplicatesPanelProps } from './types';

// Body of the Duplicates tab: one card per cross-plan near-duplicate cluster.
export const DuplicatesPanel = ({
  loading,
  loaded,
  error,
  clusters,
  editedCanonical,
  acceptedMemberKeys,
  onEditCanonical,
  onToggleMember,
  onRetry,
}: DuplicatesPanelProps) => {
  const idle = !loading && !loaded;
  const isEmpty = loaded && !loading && !error && clusters.length === 0;
  return (
    <>
      {idle && <IdleState />}
      {loading && <LoadingRow label="Comparing names across floor plans…" />}
      {error && <ErrorBlock message={error} onRetry={onRetry} />}
      {isEmpty && <EmptyState message="No near-duplicate names found ✓" />}
      {clusters.map((cluster, clusterIndex) => (
        <DuplicateClusterCard
          key={`cluster-${clusterIndex}`}
          cluster={cluster}
          clusterIndex={clusterIndex}
          canonical={editedCanonical[clusterIndex] ?? cluster.suggested}
          acceptedMemberKeys={acceptedMemberKeys}
          onEditCanonical={onEditCanonical}
          onToggleMember={onToggleMember}
        />
      ))}
    </>
  );
};
